<script setup lang="ts">
import * as zod from 'zod'
import type { TypedSchema } from 'vee-validate'

const name = 'news-contact-form'
const { t } = useI18n()
const { requiredString, optionalString } = useRules()

const validationSchema: ComputedRef<TypedSchema> = computed(() => {
  return toTypedSchema(
    zod.object({
      email: requiredString().email({
        message: t('base.form.emailNotValid'),
      }),
      country: requiredString(),
      firstname: requiredString(),
      lastname: requiredString(),
      company: optionalString(),
    })
  )
})

const { handleSubmit, errors } = useForm({
  validationSchema,
})

const { value: email } = useField<string>('email')
const { value: country } = useField<string>('country')
const { value: firstname } = useField<string>('firstname')
const { value: lastname } = useField<string>('lastname')
const { value: company } = useField<string>('company')

const onSubmit = handleSubmit((values) => {
  // TODO: https://projects.jagu.cz/issues/21844
})

const props = defineProps<{
  title: string
  description: string
}>()
</script>

<template>
  <section class="mx-auto py-16">
    <div class="mx-auto !max-w-4xl px-4">
      <h2 class="mb-4 text-center text-3xl font-bold">
        {{ props.title }}
      </h2>
      <div class="mb-16 text-center text-lg">
        {{ props.description }}
      </div>
      <form class="mx-12 my-8" @submit.prevent="onSubmit">
        <div class="mx-0 flex flex-wrap">
          <div class="w-full lg:w-1/2">
            <FormFieldInput
              v-model="firstname"
              name="firstname"
              :parent-name="name"
              property-name="firstname"
              label="base.news.form.firstname"
              :icon="'user'"
              required
              :error="errors.firstname"
            />
          </div>
          <div class="w-full lg:w-1/2">
            <FormFieldInput
              v-model="lastname"
              name="lastname"
              :parent-name="name"
              property-name="lastname"
              label="base.news.form.lastname"
              :icon="'user'"
              required
              :error="errors.lastname"
            />
          </div>
          <div class="w-full lg:w-1/2">
            <FormFieldInput
              v-model="email"
              name="email"
              :parent-name="name"
              property-name="subscription-email"
              label="base.news.form.email"
              :icon="'envelope'"
              required
              :error="errors.email"
            />
          </div>
          <div class="w-full lg:w-1/2">
            <FormFieldInput
              v-model="country"
              name="country"
              :parent-name="name"
              property-name="country"
              label="base.news.form.country"
              :icon="'globe'"
              required
              :error="errors.country"
            />
          </div>
          <div></div>
          <div class="w-full">
            <FormFieldInput
              v-model="company"
              name="company"
              :parent-name="name"
              property-name="company"
              label="base.news.form.company"
              :icon="'building'"
              :error="errors.company"
            />
          </div>
        </div>
        <button
          class="w-full border-2 border-black px-8 py-4 text-center text-xl font-bold disabled:border-neutral-400 disabled:text-neutral-400"
          type="submit"
        >
          {{ $t('base.news.form.submit') }}
        </button>
      </form>
      <div class="text-sm"></div>
    </div>
  </section>
</template>
